import React, {useEffect, useState} from "react";
import {handleError} from "../common/utils";
import agent from "../api/agent";
import {Button, Form, Input, Skeleton, Upload} from 'antd';
import {UploadOutlined} from "@ant-design/icons";
import FileUploader from "./ui/FileUploader";
import {Link} from "react-router-dom";

const ShippingMethodForm = ({
  quotes, 
  handleRateChange, 
  setAllowCheckout, 
  setRightSideLoading
}) => {
  const [selectedQuoteId, setSelectedQuoteId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [dataCollection, setDataCollection] = useState(null)
  const [dataRequiredForShip, setDataRequiredForShip] = useState(false)
  const [inputData, setInputData] = useState({})
  const [selectedQuoteInsuranceCost, setSelectedQuoteInsuranceCost] = useState(null)
  const [insuranceQuoteLoading, setInsuranceQuoteLoading] = useState(false)
  const [shippingInsuranceSelected, setShippingInsuranceSelected] = useState(false)
  const [uiElement, setUIElement] = useState('')
  const [selectedOption, setSelectedOptions] = useState({});
  const [insuranceMessage, setInsuranceMessage] = useState('')
  const [selectedQuote, setSelectedQuote] = useState({})

  const handleQuoteChange = async (quote) => {
    try {
      setIsLoading(true)
      setRightSideLoading(true)
      setSelectedOptions({})
      const { quoteId, ddp } = quote

      setSelectedQuoteId(quoteId)
      setSelectedQuote(quotes.find(quote => quote.quoteId === quoteId))
      setInputData({})

      const response = await agent.checkout.checkoutInfoCollection({quoteId: quoteId})
      const dataCollectionResp = response.data.data
      setDataCollection(dataCollectionResp)

      const DATA_REQUIRED_BEFORE_CHECKOUT = dataCollectionResp.length > 0 && !!dataCollectionResp.find(data => data.required === true)
      dataCollectionResp.find(data => data.type === 'toggleButton') ? setUIElement('toggleButton') : setUIElement('input')

      if (!DATA_REQUIRED_BEFORE_CHECKOUT) {
        const insuranceResp = await setInsuranceCost(quoteId)
        await handleRateChange({quoteId: quoteId, insurance: !!insuranceResp?.insuranceOption, dataCollection: {}})
      } else {
        setDataRequiredForShip(DATA_REQUIRED_BEFORE_CHECKOUT)
        setAllowCheckout(false)
      }
      document.querySelector(".select-ddp-title").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})

    } catch (e) {
      handleError(e)
    } finally {
      setIsLoading(false)
      setRightSideLoading(false)
    }
  }

  const handleInputDataChange = (event, dataKey) => {
    const { value } = event.target
    setInputData(prevData => ({
      ...prevData,
      [dataKey]: value
    }))
  }

  const handleToggleButtonChange = async ({data, option}) => {
    try {
      setRightSideLoading(true)
      setSelectedOptions((prevSelectedOptions) => ({
        ...prevSelectedOptions,
        ...option,
        [data.key]: option.value
      }))
  
      const dataCollection = {
        ...inputData,
        [data.key]: option.value
      }
  
      if (option.value) {
        const insuranceResp = await setInsuranceCost(selectedQuoteId)
        await handleRateChange({quoteId: selectedQuoteId, insurance: !!insuranceResp?.insuranceOption, dataCollection: dataCollection})
        setAllowCheckout(true)
      } else {
        setAllowCheckout(false)
      }
    } finally {
      setRightSideLoading(false)
    }
  }

  const handleDataCollectionSubmit = async () => {
    try {
      setIsLoading(true)
      let insuranceResp = {insuranceOption: false}
      if (selectedQuote.displayName !== 'Provide Own Label') {
        insuranceResp = await setInsuranceCost(selectedQuoteId)
      }

      await handleRateChange({quoteId: selectedQuoteId, insurance: !!insuranceResp?.insuranceOption, dataCollection: inputData})
      setAllowCheckout(true)

    }catch (e) {
      handleError(e)
    }finally {
      setIsLoading(false)
    }
  }

  const handleDynamicRequest = async (data) => {
    try {
      setIsLoading(true)
      const updateField = data.key
      const updateData = inputData[data.key]
      const {method, url} = data.request
      const body = {
        ...data.requestData,
        [updateField]: updateData
      }

      await agent.pkg.dynamicUpdate(method.toLowerCase(),url,body)
    } catch (e) {
      handleError(e)
    } finally {
      setIsLoading(false)
    }
  }

  const setInsuranceCost = async (quoteId) => {
    try {
      setInsuranceMessage('')
      setSelectedQuoteInsuranceCost(null)
      setInsuranceQuoteLoading(true)

      const response = await agent.pkg.getInsuranceCost({ quoteId })

      setShippingInsuranceSelected(true)
      setSelectedQuoteInsuranceCost(response.data.data.cost)

      return {insuranceOption: true, insuranceCost: response.data.data.cost}
    } catch (e) {
      setInsuranceMessage(`${e.response.data.message} ${e.response.data.serverMessage}`)
      setShippingInsuranceSelected(false)
      setSelectedQuoteInsuranceCost(null)
    } finally {
      setInsuranceQuoteLoading(false)
    }
  }

  const handleInsuranceChange = async (value) => {
    try {
      setIsLoading(true)
      setShippingInsuranceSelected(value)
      await handleRateChange({quoteId: selectedQuoteId, insurance: value, dataCollection: {}})
    } finally {
      setIsLoading(false)
    }
  }

  const uploadHandler = async (props) => {
    try {
      const uploadResponse = await agent.shippingQuote.uploadPdf({
        quoteId: props.quoteId,
        type: props.type,
        files: props.files
      })

      setInputData(prevData => ({
        ...prevData,
        [props.type]: uploadResponse.data.data.url
      }))
    } catch (e) {
      handleError(e)
    }
  }

  const DataCollectionComponent = () => {
    const handleFormSubmit = async (values) => {
      await handleDataCollectionSubmit(values)
    }

    if (uiElement === 'toggleButton') {
      return (
        dataCollection.map(data => (
            <div className="option-toggle-cell">
              <div>{data.description}</div>
              <div className="btn-toggle option-input-toggle">
                {data.options.map((option) => {
                  const isSelected = selectedOption[data.key] === option.value;
                  return (
                    <div className="btn-toggle option-input-toggle">
                      <button
                        className={`releaseAuth btn ${isSelected ? 'btn-selected' : ''}`}
                        onClick={async () => await handleToggleButtonChange({data, option})}>{option.label}
                      </button>
                    </div>
                  )
                })}
              </div>
              {selectedOption && <div className="option-description">{selectedOption.description}</div>}
            </div>
          )
        )
      )
    }

    return (
      <div className="option-input-cell">
        <Form
          name="dataEntryForm"
          autoComplete="off"
          onFinish={handleFormSubmit}
        >
          {dataCollection.map(data => (
              <div className="option-input-cell-content">
                <Form.Item
                  name={data.name}
                  label={data.label}
                  rules={[{required: data.required, message: `${data.label} is required`}]}
                >
                  <Input
                    type={data.keyboardType}
                    defaultValue={inputData[data.key] || ''}
                    onChange={(event) => handleInputDataChange(event, data.key)}
                    placeholder={data.placeholder ? `  ${data.placeholder}` : ''}
                  />
                </Form.Item>
              </div>
            ))}
          {
            selectedQuote.displayName === 'Provide Own Label' && (
              <>
                <Form.Item
                  label="Upload Shipping Label"
                  name="outgoingShippingLabel"
                  style={{marginTop: "20px"}}
                  rules={[{required: true, message: `Shipping Label is required`}]}
                >
                  <div style={{paddingLeft: "10px"}}>
                    <FileUploader name='label' maxNumber={1} uploadHandler={async (filesToUpload) => uploadHandler({
                      quoteId: selectedQuoteId,
                      files: filesToUpload,
                      type: 'shippingLabel'
                    })}/>
                    {inputData?.shippingLabel &&
                      <a href={`${inputData?.shippingLabel}`} target="_blank" rel="noopener noreferrer">View Uploaded Shipping Label</a>}
                  </div>
                </Form.Item>
                <Form.Item
                  label="Upload Commercial Invoice"
                  name="commercialInvoice"
                  style={{marginTop: "20px"}}
                >
                  <div style={{paddingLeft: "10px"}}>
                    <FileUploader name='label' maxNumber={1} uploadHandler={async (filesToUpload) => uploadHandler({
                      quoteId: selectedQuoteId,
                      files: filesToUpload,
                      type: 'commercialInvoice'
                    })}/>
                    {inputData?.commercialInvoice &&
                      <a href={`${inputData?.commercialInvoice}`} target="_blank" rel="noopener noreferrer">View Uploaded Commercial Invoice</a>}
                  </div>
                </Form.Item>
              </>)}
          <Form.Item>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <button className="btn btn-primary btn-small" type="submit">Submit</button>
            </div>
          </Form.Item>
        </Form>
      </div>
    )
  }

  const AddInsuranceToggle = insuranceQuoteLoading ? (
    <Skeleton active={true}/>
  ) : (
    <>
      {(
        !!selectedQuoteId && (
        <div className="ship-option" style={{ alignItems: 'center' }}>
          <div className="select-ddp mt-0 pt-0 mb-4" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div className="select-ddp-info">
              <div className="select-ddp-title">Add Insurance?</div>
              <div className="ship-quote-description">
                Insure the declared value of your package against damage and loss (up to $5000.00 USD).
                <br />
              </div>
              <div className="ship-quote-link">
                <a href="https://u-pic.com/reship-coverage" target="_blank" onClick={(e) => e.stopPropagation()}>
                  Click here to view insurance coverage terms
                </a>
              </div>
            </div>
            <div className="btn-toggle pt-2">
              <button
                className={`ddpEnable btn ${shippingInsuranceSelected ? 'btn-selected' : ''}`}
                disabled={!selectedQuoteInsuranceCost || isLoading}
                onClick={() => handleInsuranceChange(true)}
              >
                Yes
              </button>
              <button
                className={`ddpDisable btn ${!shippingInsuranceSelected ? 'btn-selected' : ''}`}
                disabled={!selectedQuoteInsuranceCost || isLoading}
                onClick={() => handleInsuranceChange(false)}
              >
                No
              </button>
            </div>
            {insuranceMessage && <div className="error-text">{insuranceMessage}</div>}
          </div>
        </div>
      ))}
    </>
  )

  return (
    <div>
      <div className="shipping-options">
        {quotes.map(quote => (
          <div key={quote.quoteId} className={`shipping-option ${Number(selectedQuoteId) === Number(quote.quoteId) ? "selected" : ""} `}>
            <div
              className={`shipping-option-content ${isLoading ? "disabled" : ""}`}
              onClick={() => {
                if (!isLoading) handleQuoteChange(quote);
              }}
              >
              {quote.ddp?.enabled && <div className="ddp-tag-2">Duty Delivery Paid</div>}
              <div className="ship-quote-select">
                {Number(selectedQuoteId) === Number(quote.quoteId) ? (
                  <div className="radio radio-checked"></div>
                ) : (
                  <div className="radio"></div>
                )}
              </div>
              <label htmlFor={quote.quoteId}>
                <div className="option-card">
                  <div className="option-details">
                    <span className="option-name">{quote.displayName}</span>
                    <span className="option-price">
                      ${quote.amount ? quote.amount.toFixed(2) : "Free"}
                    </span>
                  </div>
                  <div className="option-delivery">
                    {quote.deliveryDays.amount ? (
                      <div className="ship-quote-time">
                        Estimate {quote.deliveryDays.amount} Business Days
                      </div>
                    ) : (
                      <div className="ship-quote-time">
                        Delivery time depends on destination and cannot be guaranteed
                      </div>
                    )}
                  </div>
                  {quote.hazmatFeeDescription && (
                    <div className="ship-quote-time">{quote.hazmatFeeDescription}</div>
                  )}
                </div>
              </label>
            </div>

            {Number(selectedQuoteId) === Number(quote.quoteId) && dataCollection?.length > 0 && <div className="option-input">
              <div className="option-input-label">Please provide the following information to streamline clearance of your package</div>
              <br/>
              {isLoading ? <Skeleton active={true} paragraph={{ rows: 1 }}/> : DataCollectionComponent()}
              </div>
            }
          </div>
        ))}
      </div>
      {AddInsuranceToggle}
    </div>

  )

}

export default ShippingMethodForm